import Tweet from "../Tweet/Tweet";
import "./TweetsList.css";

export default function TweetsList(props) {
  const { tweets } = props;
  return (
    <div>
      {tweets.map((tweet) => (
        <Tweet key={tweet.id} tweet={tweet} />
      ))}
    </div>
  );
}
